// Utility to split a rawUnit object into step-wise data for the form context
import { stepFieldsMap } from "./steps/fields";

// const getFieldObj: Record<string, string> = {
// 	propertyType: "propertyType.type",
// };

function getNestedValue(obj: Record<string, unknown>, path: string): unknown {
	return path.split(".").reduce((acc, key) => {
		if (acc && typeof acc === "object" && key) {
			return (acc as Record<string, unknown>)[key];
		}
		return undefined;
	}, obj as unknown);
}

/**
 * Splits a rawUnit object into step-wise data for the form context.
 * @param rawUnit The full rawUnit object from the backend
 * @returns An object with keys for each step (profile, address, etc.)
 */
export function splitRawUnitToSteps(rawUnit: Record<string, unknown>) {
	const stepData: Record<string, unknown> = {};

	Object.entries(stepFieldsMap).forEach(([step, fields]) => {
		stepData[step] = { id: rawUnit.id }; // Include the rawUnit ID in each step
		fields.forEach(field => {
			const setField = field.name;
			const getField = setField;
			const rawUnitValue = getNestedValue(rawUnit, getField);
			if (rawUnitValue !== undefined) {
				(stepData[step] as Record<string, unknown>)[setField] = rawUnitValue;
			}
		});
	});

	return stepData;
}
